import { JSX } from "react";

const CLOSE_X_VIEWBOX = "0 0 256 256";
const CLOSE_X_PATH =
  "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z";

interface Props {
  className?: string;
  size?: number;
}

/** Same X geometry as `ModalCloseIcon` / `public/img/x.svg`. */
export const CloseIcon = ({ className = "", size = 15 }: Props): JSX.Element => {
  return (
    <svg
      className={className}
      fill="currentColor"
      height={size}
      width={size}
      viewBox={CLOSE_X_VIEWBOX}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path d={CLOSE_X_PATH} />
    </svg>
  );
};
